<template>
	<div class="dashboard-container">
		<!-- <el-tabs v-model="activeName" class="tas" type="card" @tab-click="handleClick">
          <el-tab-pane label="用户概括" name="first" >
			   <Hair></Hair>
		  </el-tab-pane>
          <el-tab-pane label="会员概括" name="two" >
          </el-tab-pane>
      </el-tabs>
	   <Hair2 v-if="show"></Hair2> -->
		<Hair></Hair>
	</div>
</template>
<script>
	import Hair from "./hair_2.vue"
	import Hair2 from "./hair3.vue"
	export default {
		components: {
			Hair,
			Hair2
		},
		data() {
			this.chartSettings = {
				label: {
					normal: {
						show: false,
					}
				}
			}
			this.chartExtend = {
				color: ['#FB697E', '#845FFD']
			}
			return {
				show: false,
				evlData: {
					columns: ["类型", "数量"],
					rows: [{
						类型: "剪发",
						数量: 1530
					}, {
						类型: "儿童剪",
						数量: 2393
					}, {
						类型: "刘海剪",
						数量: 2393
					}],
				},
				evlExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				sextend: {
					legend: {
						icon: "circle",
						right: 140,
						top: 100
					},
					series: {
						center: ["25%", "40%"]
					},
					color: ['#409EFC', '#FB697E']
				},
				evlColor: ["#FFA242", "#2DDFCF", "#FA6A7D", "#FB697E", "#845FFC"],
				sextend2: {
					legend: {
						icon: "circle",
						right: 40,
						top: 20
					},
					series: {
						center: ["40%", "40%"]
					},
					color: ['#FB697E', '#845FFD']
				},
				sextend3: {
					legend: {
						icon: "circle",
						right: 40,
						top: 20
					},
					series: {
						center: ["40%", "40%"]
					},
					color: ['#FB697E', '#845FFD']
				},
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}],
				user: '',
				listtime: '',
				data: '',
				activeName: 'first',
				friendsnum: [{
					name: '累计会员数'
				}],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				option2: [{
					value: '选项1',
					label: '今天'
				}, {
					value: '选项2',
					label: '明天'
				}, {
					value: '选项3',
					label: '后天'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				chartData: {
					columns: ['日期', '新增会员', '过期会员'],
					rows: [{
						日期: '1/1',
						新增会员: 1393,
						过期会员: 1093
					}, {
						日期: '1/2',
						新增会员: 3530,
						过期会员: 3230
					}, {
						日期: '1/3',
						新增会员: 2923,
						过期会员: 2623
					}, {
						日期: '1/4',
						新增会员: 1723,
						过期会员: 1423
					}, {
						日期: '1/5',
						新增会员: 3792,
						过期会员: 3492
					}, {
						日期: '1/6',
						新增会员: 4593,
						过期会员: 4293
					}]
				},
				chartDataloudou: {
					columns: ['状态', '数值'],
					rows: [{
						状态: '订单',
						数值: 100
					}, {
						状态: '点击',
						数值: 300
					}, {
						状态: '访问',
						数值: 600
					}]
				},
				chartData_huan: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '男',
						访问用户: 1393
					}, {
						日期: '女',
						访问用户: 3530
					}]
				},
				chartData2: {
					columns: ['日期', '访问用户'],
					rows: [{
						'日期': '新客户',
						'访问用户': 3530
					}, {
						'日期': '老客户',
						'访问用户': 1393
					}]
				}
			}
		},
		mounted() {},
		methods: {
			handleClick(tab, event) {
				console.log(this.activeName)
				if (this.activeName == "two") {
					this.show = true
				} else {
					this.show = false
				}
				// if(this.activeName=!this.activeName)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.waititle {
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.dashboard-container {
		box-sizing: border-box;

		.showlist_top {
			width: 100%;
			height: 135px;
			display: flex;

			.showlist_top1 {
				box-sizing: border-box;
				padding: 20px;
				flex: 1;
				margin-left: 20px;
				background: #f2f2f2;
				border-radius: 6px;

				>div {
					&:nth-child(1) {
						font-size: 14px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}

					&:nth-child(2) {
						font-size: 20px;
						margin-top: 10px;
						font-size: 36px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}
				}

				.bili {
					margin-top: 10px;
					display: flex;
					font-size: 14px;

					>div {
						&:nth-child(2) {
							margin-left: 10px;
						}
					}
				}

				&:nth-child(1) {
					margin: 0;
				}
			}
		}

		//
		.showlist2s {
			width: 100%;
			padding: 4px;
			box-sizing: border-box;
		}

		.showlist2 {
			padding: 20px;
			box-sizing: border-box;
			margin-top: 20px;
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

			.tubiao {
				margin-top: 20px;
			}

			.conversion {
				width: 100%;
				height: 100%;
				display: flex;

				.conversion_1 {
					flex: 1.8;
					position: relative;

					.conversion_1_list {
						display: flex;
						line-height: 32px;
						border-bottom: 1px solid #e7e7e7;
						padding-bottom: 20px;
						margin-top: 10px;

						&:nth-child(3) {
							border: none;
						}

						.lists {
							margin-left: 60px;
						}
					}

					//
					.loudou {
						width: 350px;
						top: 50%;
						margin-top: -225px;
						position: absolute;
						right: -200px;
					}
				}

				.conversion_2 {
					flex: 1;

					.xiantiao {
						width: 180px;
						height: 200px;
						margin-left: 50px;
						margin-top: 80px;
						position: relative;

						img {
							display: block;
							margin-left: 30px;
							width: 180px;
							height: 200px;
						}

						.rate {
							position: absolute;
							width: 200px;
							height: 180px;
							right: 0;
							top: 0;

							.rates {
								line-height: 2px;
							}

							.rate1 {
								top: 30px;
								right: -28px;
								position: absolute;
							}

							.rate2 {
								top: 110px;
								right: -28px;
								position: absolute;
							}

							.rate3 {
								top: 70px;
								right: -98px;
								position: absolute;
							}
						}
					}
				}
			}

			//
			.attributes_con {
				display: flex;

				.attributes_con1 {
					flex: 1;

					&:nth-child(1) {
						box-sizing: border-box;
					}
				}

				.shuxian {
					border-left: 1px solid #e7e7e7;
					height: 220px;
					margin-top: 50px;
				}

				.attributes_con2 {
					display: flex;

					>div {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						flex: 1;
						margin-top: 40px;
						text-align: center;

						>p {
							&:nth-child(1) {
								color: #9A9A9A;
							}

							margin-top: 40px;

						}
					}
				}

				.attributes_1 {
					display: flex;

					.con1_tu {
						flex: 1;
						display: flex;

						>div {
							flex: 1;
						}

						.con1_title {
							.con1_titles {
								padding-top: 80px;
								display: flex;

								.con1_title1 {
									display: flex;
									margin-right: 50px;
									margin-left: 40px;

									&:nth-child(1) {}

									.yuan_blue {
										width: 10px;
										height: 10px;
										background-color: blue;
										border-radius: 50%;
										margin-top: 3px;
										margin-right: 5px;
									}

								}
							}
						}
					}
				}
			}

			.attributes_bottom {
				position: relative;
				top: -20px;
			}
		}
	}

	.new_and_old_warp {
		margin-top: 25px;
	}

	.newolder {
		margin-top: 15px;
	}

	.newo {
		display: flex;
		width: 100%;
	}

	.newo1 {
		flex: 2;
	}

	.newo2_title {
		flex: 1;
	}

	.newo2 {
		flex: 3.5;
		margin-top: 50px;
	}

	.newo2_title {
		margin-top: 45px;
		margin-bottom: 45px;
		display: flex;
	}

	.newo2_title>div {
		box-sizing: border-box;
		display: flex;
		flex: 1;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
	}

	.yuan1 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #FB697E;
		border-radius: 50%;
	}

	.yuan2 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #845FFD;
		border-radius: 50%;
	}

	.new2_table {
		box-sizing: border-box;
		padding-right: 20px;
	}

	.demo3 {
		margin-top: 20px;
		display: flex;
	}

	.demo3>div:nth-child(1) {
		flex: 3.2;
	}

	.demo3>div:nth-child(2) {
		flex: 2;
	}

	.demo3>div:nth-child(1) {
		margin-right: 20px;
	}
</style>